// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FOOTER_DOWNLOAD_ON_APP_STORE = "St\u00e1hni z App Store";
export const INSTALL_PROMPT_DESCRIPTION = "P\u0159idej si ikonku Modr\u00e9ho kon\u00edka na plochu mobilu";
export const INSTALL_PROMPT_DOWNLOAD_APP = "P\u0159idej";
